import { useTranslation } from 'react-i18next';
import { HStack, Box, Text } from '@chakra-ui/core';
import { MdCheck } from 'react-icons/md';
import React from 'react';

interface SelectionSummaryProps {
  selectedCount: number;
  totalCount: number | undefined;
  isAllSelected: boolean;
  onSelectAll: () => void;
  onClearAll: () => void;
}

export const SelectionSummary = React.memo(function SelectionSummary({
  selectedCount,
  totalCount,
  isAllSelected,
  onSelectAll,
  onClearAll,
}: SelectionSummaryProps) {
  const { t } = useTranslation('moniterByRecruiters');

  const getSuffix = (count: number) => {
    if (count === 0) return '_empty';
    if (count > 1) return '_plural';
    return '';
  };

  const countSuffix = getSuffix(selectedCount);
  return (
    <HStack spacing={2}>
      {isAllSelected && (
        <Box background="#AED0FF" p={1} rounded="3xl">
          <MdCheck color="#263DBA" />
        </Box>
      )}

      <HStack spacing={0} flexWrap="wrap">
        {selectedCount > 0 && (
          <Text fontSize="sm" textColor="gray.700" fontWeight={600} px={1}>
            {selectedCount}
          </Text>
        )}
        {!isAllSelected && (
          <Text fontSize="sm" textColor="gray.700">
            {t(`bulk.selectionCountInfo.message${countSuffix}`)}
          </Text>
        )}

        {isAllSelected && (
          <Text fontSize="sm" textColor="gray.700" px={1}>
            {t(`bulk.selectionCountInfo.allSelected`, { totalCount })}
          </Text>
        )}
      </HStack>
      {selectedCount !== totalCount &&
        (isAllSelected ? (
          <Text
            color="#263DBA"
            fontSize="sm"
            textColor="blue.500"
            fontWeight={600}
            cursor="pointer"
            _hover={{ textDecoration: 'underline' }}
            onClick={onClearAll}
          >
            {t(`bulk.selectionCountInfo.clearSelection`)}
          </Text>
        ) : (
          <Text
            spacing={0}
            sx={{ textDecoration: 'underline' }}
            color="blue.500"
            cursor="pointer"
            fontSize="sm"
            onClick={onSelectAll}
            fontWeight={600}
          >
            {t(`bulk.selectionCountInfo.selectAll`, { totalCount })}
          </Text>
        ))}
    </HStack>
  );
});
